import { sendRequestModule } from "../modules/sendRequestModule";


export function loadCheckoutForm(cart) {

        // Create Finish Request Loader on Click of Submit Button

        let form = jQuery('.checkout-form');

        jQuery([document.documentElement, document.body]).animate({
            scrollTop: form.offset().top - 100
        }, 1000);


        form.on("submit", (e) => {
            e.preventDefault();

            let contactData = {};
            let formSerializedData = form.serializeArray()
            for(let entry of formSerializedData) {
                contactData[entry.name] = entry.value;
            }                       
            
            console.log(contactData)

            sendRequestModule.sendRequest(cart, contactData);

            let finishRequestModal = createFinishRequestModal();
            document.getElementsByTagName("body")[0].appendChild(finishRequestModal)
        })

        sendRequestModule.on("loadComplete", () => {
            //jQuery("#finishing-request-wrapper").fadeOut();
            let svgReady = `
                <svg id="checkmark-svg"  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 193.3 193.3"><circle class="cls-1 circle" cx="96.65" cy="96.65" r="94.15"/><polyline class="cls-1 checkmark" points="46.9 101.4 76.9 131.4 146.4 61.9"/></svg>
            `;
            jQuery("#loading-bounce-wrapper").html(svgReady)
            jQuery("#loading-bounce-wrapper > svg").addClass("run-animation")


            jQuery("#finishing-request-heading").text("Vielen Dank!")
            jQuery("#finishing-request-text").html("Wir haben Ihre Anfrage erhalten. <br>Sie erhalten schnellstmöglich ein Angebot von uns.<br><br>Wir leiten Sie gleich weiter.")

            setTimeout(() => {
                window.location.replace(cloudmanufaktur.homeUrl)
            },5000)

            localStorage.setItem('cart', null)
            // delete Cart from local storage
        })

        sendRequestModule.on("error", (message) => {
            jQuery("#finishing-request-text").text(message)
        })
        
        sendRequestModule.on("create", (data) => {
            console.log(data)
        })

}






function createFinishRequestModal() {
    let finishRequestElement = document.createElement("div");
    finishRequestElement.classList.add("finishing-request-wrapper");
    finishRequestElement.id = "finishing-request-wrapper"

    let loadingBounceWrapper = document.createElement("div")
    loadingBounceWrapper.classList.add("loading-bounce")
    loadingBounceWrapper.id = 'loading-bounce-wrapper';
    let loadingBounceWrapperDiv = document.createElement("div")
    let loadingBounceWrapperDiv2 = document.createElement("div")
    let loadingBounceWrapperDiv3 = document.createElement("div")
    loadingBounceWrapper.appendChild(loadingBounceWrapperDiv)
    loadingBounceWrapper.appendChild(loadingBounceWrapperDiv2)
    loadingBounceWrapper.appendChild(loadingBounceWrapperDiv3)

    
    let finishRequestHeadingElement = document.createElement("div")
    finishRequestHeadingElement.id = "finishing-request-heading"
    finishRequestHeadingElement.classList.add("sp-m")
    finishRequestHeadingElement.innerText = "Wir verarbeiten Ihre Anfrage."
    
    let finishRequestTextElement = document.createElement("div")
    finishRequestTextElement.classList.add("d-block")
    finishRequestTextElement.id = "finishing-request-text"
    finishRequestTextElement.innerText = "Einen Augenblick noch..."

    finishRequestElement.appendChild(loadingBounceWrapper)
    finishRequestElement.appendChild(finishRequestHeadingElement)
    finishRequestElement.appendChild(finishRequestTextElement)

    return finishRequestElement;
}